import { useParams } from 'react-router-dom'

export const useOrderIdParam = () => {
  const { orderId = '' } = useParams<'orderId'>()

  return { orderId }
}
